import icons from "../../../icons.js";
// https://github.com/dgwyer/server-side-render-x
import { ServerSideRenderX } from "./server-side-render-x";

const { __ } = wp.i18n; // Import __() from wp.i18n
const { registerBlockType } = wp.blocks; // Import registerBlockType() from wp.blocks
const { InspectorControls } = wp.blockEditor;
const {
  SelectControl,
  PanelBody,
  PanelRow,
  ToggleControl,
  Disabled,
  Placeholder,
  FormTokenField,
  RangeControl,
} = wp.components;
const { withSelect } = wp.data;
//const { serverSideRender: ServerSideRender } = wp;
const { createElement: el } = wp.element;
/**
 * Internal dependencies
 */
import store from "../../../store";

/**
 * Register: aa Gutenberg Block.
 *
 * Registers a new block provided a unique name and an object defining its
 * behavior. Once registered, the block is made editor as an option to any
 * editor interface where blocks are implemented.
 *
 * @link https://wordpress.org/gutenberg/handbook/block-api/
 * @param  {string}   name     Block name.
 * @param  {Object}   settings Block settings.
 * @return {?WPBlock}          The block, if it has been successfully
 *                             registered; otherwise `undefined`.
 */

registerBlockType("wp-apidae/apidae-block-archive", {
  // Block name. Block names must be string that contains a namespace prefix. Example: my-plugin/my-custom-block.
  title: __("Sélection Apidae", "wp-apidae"), // Block title.
  icon: icons.archive, // Block icon from Dashicons → https://developer.wordpress.org/resource/dashicons/.
  description: __(
    "Affiche une sélection Apidae. Ce bloc est déprécié, Nous vous invitons à utiliser le nouveau système de bloc et modèles",
    "wp-apidae"
  ),
  keywords: [
    __("apidae archive", "wp-apidae"),
    __("archive", "wp-apidae"),
    __("sélection", "wp-apidae"),
    __("selection", "wp-apidae"),
    __("apidae", "wp-apidae"),
  ],
  supports: {
    align: true,
  },
  example: {
    attributes: {
      types: "",
    },
  },
  attributes: {
    selections: {
      type: "string",
      default: "",
    },
    limit: {
      type: "number",
      default: 20,
    },
    disable_filters: {
      type: "array",
      default: [],
    },
    forced_terms: {
      type: "array",
      default: [],
    },
    hidden_terms: {
      type: "array",
      default: [],
    },
    orders_filter: {
      type: "array",
      default: [],
    },
    is_agenda: {
      type: "boolean",
      default: false,
    },
    show_map: {
      type: "boolean",
      default: false,
    },
    map_width: {
      type: "number",
      default: 30,
    },
  },
  /**
   * The edit function describes the structure of your block in the context of the editor.
   * This represents what the editor will render when the block is used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
   *
   * @param {Object} props Props.
   * @returns {Mixed} JSX Component.
   */
  edit: ({ attributes, setAttributes, store }) => {
    const {
      selections,
      limit,
      show_map,
      is_agenda,
      disable_filters,
      orders_filter,
      map_width,
    } = attributes;
    const customTooltipMapWidthContent = (value) => `${value}%`;

    /**
     * Set selections
     */
    function onChangeSelections(value) {
      setAttributes({ selections: value });
    }

    /**
     * Set limit
     */
    function onChangelimit(value) {
      setAttributes({ limit: value });
    }

    /**
     * Set map width
     */
    function onChangeMapWidth(value) {
      setAttributes({ map_width: value });
    }

    /**
     * Define show map
     */
    function toggleShowMap() {
      setAttributes({ show_map: !show_map });
    }

    /**
     * Define filter date to show
     */
    function toggleIsAgenda() {
      setAttributes({ is_agenda: !is_agenda });
    }

    /**
     * Set disable filters.
     */
    function onChangeDisableFilters(value) {
      setAttributes({ disable_filters: value });
    }

    /**
     * Define Orders filter
     */
    function onChangeOrdersFilter(value) {
      setAttributes({ orders_filter: value });
    }

    function showAgendaButton() {
      return (
        <PanelRow>
          <ToggleControl
            label={__("Classer par date", "wp-apidae")}
            checked={is_agenda}
            onChange={toggleIsAgenda}
            help={__("Les fiches sans dates ne seront pas visible")}
          />
        </PanelRow>
      );
    }

    function ShowPlaceHolder() {
      if ("" === selections) {
        return (
          <Placeholder
            icon={icons.base}
            label={__("Sélection Apidae", "wp-apidae")}
          >
            {el(SelectionsSelect)}
          </Placeholder>
        );
      } else {
        return (
          <Disabled>
            <ServerSideRenderX
              block="wp-apidae/apidae-block-archive"
              attributes={{
                selections: selections,
                limit: limit,
                show_map: show_map,
                is_agenda: is_agenda,
                disable_filters: disable_filters,
                orders_filter: orders_filter,
                map_width: map_width,
              }}
              spinnerLocation={{ right: 0, top: 10, unit: "px" }}
            />
          </Disabled>
        );
      }
    }

    function showMapWidth() {
      if (show_map) {
        return (
          <RangeControl
            label={__("Largeur de la carte", "wp-apidae")}
            value={map_width}
            onChange={onChangeMapWidth}
            step={5}
            renderTooltipContent={customTooltipMapWidthContent}
            min={30}
            max={70}
          />
        );
      }
    }
    /**
     * Select selections.
     */
    const SelectionsSelect = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        selectionsData: select("wpdae/data").getSelectionsList(),
        isRequesting: isResolving("wpdae/data", "getSelectionsList", []),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des sélections...");
      }

      const selections_list = [{ value: "", label: "choisir une sélection" }];
      for (const [key, value] of Object.entries(props.selectionsData)) {
        selections_list.push({ value: value.id, label: value.name });
      }

      return (
        <SelectControl
          onChange={onChangeSelections}
          value={selections}
          label={__("Choisir une selection Apidae", "wp-apidae")}
          options={selections_list}
        />
      );
    });

    /**
     * Disable filter.
     */
    const DisableFilter = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        taxo: select("wpdae/data").getTaxonomiesList(selections),
        isRequesting: isResolving("wpdae/data", "getTaxonomiesList", [
          selections,
        ]),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des terms...");
      }
      const common_taxonomies_suggestion = [];
      for (const [key, value] of Object.entries(props.taxo)) {
        common_taxonomies_suggestion.push(value);
      }
      return (
        <FormTokenField
          value={disable_filters}
          suggestions={common_taxonomies_suggestion}
          onChange={onChangeDisableFilters}
          placeholder={__("Cacher un filtre", "wp-apidae")}
          label={__("Cacher des filtres", "wp-apidae")}
        />
      );
    });

    /**
     * Order results by criteres internes
     */
    const OrderFilter = withSelect((select) => {
      const { isResolving } = select("core/data");
      return {
        taxonomies: select("core").getEntityRecords(
          "taxonomy",
          "at_criteresinternes",
          { per_page: -1 }
        ),
        isRequesting: isResolving("core", "getEntityRecords", [
          "taxonomy",
          "at_criteresinternes",
          { per_page: -1 },
        ]),
      };
    })((props) => {
      if (props.isRequesting) {
        // still resolving; so display a "loading" indicator
        return el("div", null, "Chargement des critères internes...");
      } else {
        if ( null === props.taxonomies ) {
          return el("div", null, "Chargement des critères internes...");
        }
        let taxoNames = [];
        let taxosFieldValue = [];
        

        taxoNames = props.taxonomies.map((taxo) => taxo.name);
        taxosFieldValue = attributes.orders_filter.map((taxoID) => {
          let wantedTaxo = props.taxonomies.find((taxo) => {
            return taxo.slug === taxoID;
          });
          if (wantedTaxo === undefined || !wantedTaxo) {
            return false;
          }
          console.log( props );
          return wantedTaxo.name;
        });
        return (
          <FormTokenField
            value={taxosFieldValue}
            suggestions={taxoNames}
            onChange={(orders_filter) => {
              let selectedTaxosArray = [];
              orders_filter.map((taxoName) => {
                const matchingTaxo = props.taxonomies.find((taxo) => {
                  return taxo.name === taxoName;
                });
                if (matchingTaxo !== undefined) {
                  selectedTaxosArray.push(matchingTaxo.slug);
                }
              });
              setAttributes({ orders_filter: selectedTaxosArray });
            }}
            placeholder={__("Ajouter un critère", "wp-apidae")}
            label={__(
              "Ordonner les résultats par critères internes",
              "wp-apidae"
            )}
          />
        );
      }
    });

    /**
     * Return
     */
    return [
      <InspectorControls key="inspector">
        <PanelBody title="Configuration remontée">
          <PanelRow>{el(SelectionsSelect)}</PanelRow>
          <RangeControl
            label={__("Résultat par page", "wp-apidae")}
            value={limit}
            onChange={onChangelimit}
            min={1}
            max={50}
          />
          <ToggleControl
            label={__("Afficher les résultats sur la carte", "wp-apidae")}
            checked={show_map}
            onChange={toggleShowMap}
          />
          {showMapWidth()}
          {showAgendaButton()}
        </PanelBody>
        <PanelBody title="Configuration avancée" initialOpen={false}>
          {el(DisableFilter)}
          {el(OrderFilter)}
        </PanelBody>
      </InspectorControls>,
      ShowPlaceHolder(),
    ];
  },

  /**
   * The save function defines the way in which the different attributes should be combined
   * into the final markup, which is then serialized by Gutenberg into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
   *
   * @param {Object} props Props.
   * @returns {Mixed} JSX Frontend HTML.
   */
  save: () => {
    return null;
  },
});
